// extracted by mini-css-extract-plugin
export default {"tx":"_005eef862d","line":"_79c0386eff"};